import Link from 'next/link';
import paths from '@/paths';
import { ButtonClassic } from '@/components/buttons/ButtonClassic';
import { usePathname, useRouter } from 'next/navigation';
import { useHideOnScroll } from './hooks/useHideOnScroll';

export const HeaderWithExitButton = () => {
  const router = useRouter();
  const pathname = usePathname();
  const handleExit = () => router.push(paths.home());
  const hidden = useHideOnScroll();

  return (
    <header className={`sticky w-full top-0 left-0 px-4 bg-header backdrop-blur-md border-b border-gray-800 z-[1100] transition-transform duration-300 ${hidden ? "-translate-y-full" : "translate-y-0"}`}>
      <div className="main-container relative mx-auto h-100 min-h-20 flex flex-wrap items-center justify-between">
        <div className="w-fit lg:w-fit flex justify-start z-[2]">
          <Link href={paths.home()}>
            <img src="/static/images/logo.png" alt="FaunaExplore logo" height={42} width={37} />
          </Link>
        </div>

        <div className="w-fit lg:w-fit min-h-20 flex items-center justify-end gap-3 z-[2]">
          <ButtonClassic className="border border-gray-700" handleClick={handleExit}>
            {pathname.includes('draft') ? 'Save & Exit' : 'Exit'}
          </ButtonClassic>
        </div>
      </div>
    </header>
  );
};
